import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "help",
  "use": "help-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"help\"><title>资源 40</title><g data-name=\"图层 2\"><path d=\"M3.51 20.49a12 12 0 1 1 17 0 12 12 0 0 1-17 0zM8 2.5a10.31 10.31 0 1 0 8 0 10.32 10.32 0 0 0-8 0zm3.36 16.41a1 1 0 0 1 1-1.77 1 1 0 0 1 .37 1.39 1 1 0 0 1-.88.51 1 1 0 0 1-.51-.13zm.45-3.36a.83.83 0 0 1-.75-.92A5.4 5.4 0 0 1 13 11.57c1.52-1.51 1.54-2 1.57-2.5a2.21 2.21 0 0 0-.62-1.62A2.66 2.66 0 0 0 12 6.64a2.54 2.54 0 0 0-2.52 2.52.84.84 0 0 1-1.68 0A4.21 4.21 0 0 1 12 5a4.34 4.34 0 0 1 3.13 1.34 3.83 3.83 0 0 1 1.07 2.82c-.06 1.09-.39 1.94-2.06 3.6-.84.84-1.37 1.48-1.43 2a.83.83 0 0 1-.84.76h-.08z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/help.svg
// module id = /9hz
// module chunks = 6